module.exports = __webpack_public_path__ + "img/89.4.NH3-N.349bccc5.png";